import { useState, useRef, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '@/lib/i18n';

const languages = [
  { code: 'en', flag: 'GB', label: 'English' },
  { code: 'hi', flag: 'IN', label: 'हिन्दी' },
  { code: 'gu', flag: 'IN', label: 'ગુજરાતી' },
  { code: 'hinglish', flag: 'HI', label: 'Hinglish' },
];

export default function LanguageSwitcher() {
  const { language, setLanguage, t } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className="relative px-3">
      <button
        onClick={() => setOpen(!open)}
        data-testid="language-switcher-btn"
        className="flex items-center gap-3 px-4 py-3 w-full text-gray-400 hover:text-white rounded-xl hover:bg-white/10 transition-all text-base"
      >
        <Globe className="w-5 h-5 flex-shrink-0" />
        <span className="text-sm">{languages.find(l => l.code === language)?.label}</span>
      </button>

      {open && (
        <div className="absolute bottom-full left-3 mb-2 bg-white rounded-2xl shadow-2xl border border-gray-100 w-52 overflow-hidden z-50 animate-fade-in-up">
          <div className="px-4 py-2.5 text-xs font-bold text-gray-400 uppercase tracking-wider border-b border-gray-50">
            {t('lang_title')}
          </div>
          {languages.map(lang => (
            <button
              key={lang.code}
              data-testid={`lang-${lang.code}`}
              onClick={() => { setLanguage(lang.code); setOpen(false); }}
              className={`w-full text-left px-4 py-3 flex items-center gap-3 text-base transition-all ${
                language === lang.code
                  ? 'bg-[#f0a500]/10 text-[#f0a500] font-semibold'
                  : 'text-[#1a1a2e] hover:bg-gray-50'
              }`}
            >
              <span className="text-sm font-mono w-7 text-gray-400">{lang.flag}</span>
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
